<template>
    <div class="flex flex-col">
        <form method="POST" action="/suggested-drains/create/guest">
            <input type="hidden" name="_token" :value="token" />
            <div class="w-full p-12 pb-8">
                <div class="text-center">
                    <div class="mb-8 text-2xl leading-tight">
                        Drag the map to move the red pin to your drain.
                    </div>
                    <div v-if="this.user != null" class="flex items-stretch">
                        <label
                            for="drain_name"
                            class="w-1/4 pt-2 pr-3 text-sm text-right align-middle text-grey-darkest"
                        >
                            Give this drain a name
                        </label>
                        <div class="flex flex-col w-3/4">
                            <input
                                id="drain_name"
                                type="text"
                                name="drain_name"
                                value=""
                                required="required"
                                class="h-8 px-2 border rounded grow border-grey-light"
                            />
                        </div>
                    </div>

                    <p class="mt-6 text-lg">
                        <input
                            type="checkbox"
                            v-model="confirmWillAdoptSuggestion"
                            class="mr-4"
                            id="confirm"
                        />
                        <label for="confirm" class="cursor-pointer"
                            >I understand that by adding this drain I am also
                            adopting it</label
                        >
                    </p>
                </div>
            </div>

            <div class="w-full">
                <map-suggest
                    :adopted-drain-ids="adoptedDrainIds"
                    :height="430"
                    :initial-center="center"
                    :initial-zoom="initialZoom"
                    :my-drain-ids="myDrainIds"
                    :confirm-will-adopt-suggestion="confirmWillAdoptSuggestion"
                    :user="user"
                />
            </div>

            <div
                class="w-full p-4 text-center"
                style="background: rgb(194, 221, 221);"
            >
                <div class="flex items-stretch">
                    <label
                        for="gmap-autocomplete"
                        class="pt-2 pr-3 font-bold text-right align-middle text-grey-darkest text-md sm:w-1/4 "
                        >Lost? Re-center map to</label
                    >
                    <div class="flex flex-col sm:w-3/4 md:max-w-lg">
                        <autocomplete @placeChanged="({center}) => this.center = center"></autocomplete>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import MapSuggest from './MapSuggest';
import GoogleMapMarker from './GoogleMapMarker';
import Autocomplete from './Autocomplete';

export default {
    components: { MapSuggest, GoogleMapMarker, Autocomplete},

    props: {
        adoptedDrainIds: { default: null },
        initialCenter: {},
        initialZoom: {},
        myDrainIds: { default: null },
        selectedDrain: { default: null },
        user: { default: null },
    },

    computed: {
        token() {
            return window.token.content;
        },
    },

    data() {
        return {
            confirmWillAdoptSuggestion: false,
            center: this.initialCenter,
        };
    },

    methods: {
        setPlace(place) {
            this.center = place.geometry.location;
        },
    },
};
</script>
